module.exports = __webpack_public_path__ + "img/strip-deco.9fbf0db4.png";